
import { Component, Vue, Prop, Model, Emit } from "vue-property-decorator";
import ModalTitle from "@/lib/model/exam/modal-title";
import ModalHeader from "@/components/modal-header.vue";
import { ExamCopyForm } from "@/lib/form/exam/ExamListForm";
import ExamList from "@/lib/model/exam/exam";

@Component({
  components: {
    ModalHeader
  }
})
export default class CopyExamModal extends Vue {
  name = "copy-exam-modal";
  @Prop() private examCopyForm!: ExamCopyForm;
  @Prop() private isShowCopyModal!: boolean;
  @Prop() private examName!: string;
  @Prop() private modalTitle!: ModalTitle;

  copying = false;

  mounted() {
    this.modalTitle.hasDesc = true;
    this.modalTitle.title = "复制面试";
  }

  @Emit("on-copy-cancel")
  copyCancel() {
    return;
  }

  @Emit("on-copy-success")
  copySuccess() {
    return;
  }

  copySubmit() {
    if (this.copying) {
      return;
    }
    this.copying = true;
    ExamList.examCopy(this.examCopyForm).then(res => {
      if (res.code === 0) {
        setTimeout(() => {
          this.copying = false;
        }, 1000);
        this.copySuccess();
      }
    });
  }
}
